(function () {
  var state = { products: [], index: 0 };

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-PT', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR' });
  }

  function getContainer() {
    return document.getElementById('CartDrawer-Recommendations');
  }

  function renderCurrent() {
    var container = getContainer();
    if (!container) return;
    var products = state.products;

    if (!products.length) {
      container.innerHTML = '';
      return;
    }

    if (state.index >= products.length) state.index = 0;
    var p = products[state.index];
    var variant = p.variants && p.variants[0];
    if (!variant) return;

    var image = (variant.featured_image && variant.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '';
    var imageUrl = image ? image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    var hasDiscount = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);

    var html = '<p class="cart-drawer__recs-title">Também costumam comprar</p>';
    html += '<div class="cart-drawer__recs-carousel">';
    html += '<button type="button" class="cart-drawer__recs-nav" data-dir="-1"' + (products.length < 2 ? ' disabled' : '') + ' aria-label="Anterior">‹</button>';
    html += '<div class="cart-drawer__rec-card">';
    html += '<a class="cart-drawer__rec-link" href="' + (p.url || ('/products/' + p.handle)) + '">';
    html += '<img src="' + imageUrl + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="200" height="200">';
    html += '<div class="cart-drawer__rec-info">';
    html += '<span class="cart-drawer__rec-title">' + p.title + '</span>';
    html += '<div class="cart-drawer__rec-price">';
    if (hasDiscount) {
      html += '<s>' + formatMoney(Math.round(parseFloat(variant.compare_at_price) * 100)) + '</s>';
    }
    html += '<strong>' + formatMoney(Math.round(parseFloat(variant.price) * 100)) + '</strong>';
    html += '</div>';
    html += '</div>';
    html += '</a>';
    html += '<button type="button" class="cart-drawer__rec-add" data-variant-id="' + variant.id + '" aria-label="Adicionar ' + (p.title || '').replace(/"/g, '&quot;') + '">+</button>';
    html += '</div>';
    html += '<button type="button" class="cart-drawer__recs-nav" data-dir="1"' + (products.length < 2 ? ' disabled' : '') + ' aria-label="Seguinte">›</button>';
    html += '</div>';

    container.innerHTML = html;

    container.querySelectorAll('.cart-drawer__recs-nav').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-dir'), 10);
        state.index = (state.index + dir + state.products.length) % state.products.length;
        renderCurrent();
      });
    });

    var addBtn = container.querySelector('.cart-drawer__rec-add');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addBtn.disabled = true;
        addToCart(addBtn.getAttribute('data-variant-id')).finally(function () {
          addBtn.disabled = false;
        });
      });
    }
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cartState) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(cartState);
        }
      });
  }

  function setProducts(products, excludeIds) {
    state.products = (products || []).filter(function (p) {
      return excludeIds.indexOf(p.id) === -1;
    }).slice(0, 8);
    state.index = 0;
    renderCurrent();
  }

  function loadFallback(excludeIds) {
    fetch('/collections/all/products.json?limit=8')
      .then(function (r) { return r.json(); })
      .then(function (data) { setProducts(data.products, excludeIds); })
      .catch(function () {});
  }

  function loadRecommendations() {
    var container = getContainer();
    if (!container) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          container.innerHTML = '';
          return;
        }
        var excludeIds = cart.items.map(function (i) { return i.product_id; });
        var firstProductId = cart.items[0].product_id;
        return fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=6&intent=complementary')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.products && data.products.length) {
              setProducts(data.products, excludeIds);
            } else {
              loadFallback(excludeIds);
            }
          });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    loadRecommendations();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(loadRecommendations, 150);
      });
    }
  });
})();
